import React from 'react';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: ${rem(10)};
  margin: ${rem(10)};
  overflow: auto;
  box-shadow: 0 ${rem(3)} ${rem(5)} 0 rgba(0, 0, 0, 0.16);
  &:hover {
    box-shadow: 0 0 ${rem(8)} ${rem(0)} #70af00;
  }
  cursor: pointer;
  background-image: linear-gradient(to bottom, #ffffff, #ffffff, #f0f0f0);
`;

const TableItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #434245;
  font-size: 12px;
`;

const TableItemProduct = styled(TableItem)`
  justify-content: flex-start;
  width: ${rem(150)};
`;

const ItemName = styled.div`
  font-size: 11px;
  color: #70af00;
`;

const ItemProductName = styled.div`
  white-space: nowrap;
  max-width: ${rem(140)};
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: ${rem(8)};
`;

const SurfaceWrapper = styled.div`
  white-space: nowrap;
  width: ${rem(210)};
  overflow: hidden;
  text-overflow: ellipsis;
`;

class PaintSystemCard extends React.Component {
  render() {
    const { data, onClick } = this.props;
    return (
      <Wrapper onClick={() => onClick(data._id)}>
        <TableItem style={{ width: rem(80) }}>{data.code}</TableItem>
        <TableItem style={{ width: rem(120) }}>{data.producer_code}</TableItem>
        <TableItem style={{ width: rem(220) }}>
          {data.surfaces.map(d => (
            <SurfaceWrapper>{d}</SurfaceWrapper>
          ))}
        </TableItem>
        <TableItem style={{ width: rem(250) }}>
          {data.layers.map(l => (
            <TableItemProduct>
              <ItemName>{l.layer}</ItemName>
              <ItemProductName>{l.product_name}</ItemProductName>
            </TableItemProduct>
          ))}
        </TableItem>
        <TableItem style={{ width: rem(100) }}>{data.total_hsf}</TableItem>
        <TableItem style={{ width: rem(150) }}>{data.brand}</TableItem>
        <TableItem style={{ width: rem(120) }}>
          {data.int_ext.map(d => (
            <div>{d}</div>
          ))}
        </TableItem>
        <TableItem>{data.system_type}</TableItem>
      </Wrapper>
    );
  }
}

PaintSystemCard.propTypes = {
  onClick: PropTypes.func.isRequired,
  data: PropTypes.shape({}).isRequired,
};

export default PaintSystemCard;



// WEBPACK FOOTER //
// ./src/Containers/ProductCatalog/Components/PaintSystemsCard/index.jsx